export default __webpack_public_path__ + "static/media/Hermoso.a2687fd1.jpg";